import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { OptimizelyProject } from '~/adapters/optimizely/optimizelyProjects';

export const useOptimizelyQueryParam = () => {
    const { search } = useLocation();
    return useMemo(() => {
        return new URLSearchParams(search).get('project') ?? OptimizelyProject.accounts;
    }, [search]);
};
